export default __webpack_public_path__ + "static/media/gorin_gif.090df4ec.gif";